import fetcher from "../../lib/fetcher";
import { IGeoPolygonsSchema } from "./use-geo-polygon";
import useSWRMutation from "swr/mutation";

interface IGeoPolygonByBuildingResponse {
  data: IGeoPolygonsSchema;
}

const ERROR_MESSAGE = "Не удалось получить данные полигона по заданому зданию";

const useGeoPolygonByBuilding = () => {
  async function fetchGeoPolygonByBuilding(
    url: string,
    { arg }: { arg: number | null }
  ) {
    try {
      const data = await fetcher.swr<IGeoPolygonByBuildingResponse>(url, {
        params: { buildingId: arg },
      });

      return data.data as IGeoPolygonsSchema;
    } catch (error) {
      throw ERROR_MESSAGE;
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    "/geo/polygon-by-building",
    fetchGeoPolygonByBuilding
  );

  return {
    itemGeoPolygon: data ?? [],
    error,
    isMutating,
    trigger,
  };
};

export default useGeoPolygonByBuilding;
